import React, { useState } from 'react';
import { Minus, MoreVertical } from "react-feather";
import { useSelector } from 'react-redux';
import { useIntl } from "react-intl";

import CommandBar from '../../../../commandBar/CommandBar';
import { ContextMenu, ContextMenuButton } from '../../../../contextMenu';
import { Heading } from "../../../../typography";

import GroupAvatar from "../../groupAvatar/GroupAvatar";
import { GROUP_MANAGEMENT_VIEWS } from "../../groupManagement/GroupManagement";
import { canManageGroup, getTokenRole } from "../../../../../utils/internalChatGroups";

import "./header.scss";

const GroupHeader = ({ group, closeChatWindow, openGroupManagement }) => {

    const intl = useIntl();
    const loggedUserId = useSelector(state => state.auth.userData?.id);
    const accessToken = useSelector(state => state.auth.user?.access_token);

    const [groupMenu, showGroupMenu] = useState(null);

    /** Quem participa, com o usuário logado como "Você". Só com a lista conhecida:
     *  o grupo vindo da listagem não a traz até a busca ao abrir voltar.
     */
    const participantsLabel = React.useMemo(() => {
        if (!Array.isArray(group?.participants)) return null;

        const loggedUser = group.participants.filter(participant => participant.userId === loggedUserId)
            .map(() => intl.formatMessage({ id: "Você" }));
        const others = group.participants.filter(participant => participant.userId !== loggedUserId)
            .map(participant => participant.userName);

        return [...loggedUser, ...others].join(', ');
    }, [group, loggedUserId, intl]);

    /** "Participantes" aparece para quem gerencia ou quando a lista é conhecida;
     *  renomear e excluir, só para quem gerencia. Sem nenhum item, não há menu.
     */
    const canManage = React.useMemo(() => {
        return canManageGroup(group, getTokenRole(accessToken), loggedUserId);
    }, [group, accessToken, loggedUserId]);
    const showParticipants = canManage || Array.isArray(group?.participants);

    return (
        <div className="chat-window-header-ui">
            <div className="chat-window-header-user chat-window-header-group">
                <GroupAvatar group={group} size="lg" />
                <div className="chat-window-header-user-info">
                    <Heading type="h6" fw={600} color="primary">{group?.name}</Heading>
                    {participantsLabel &&
                        <span className="chat-window-header-participants" title={participantsLabel}>{participantsLabel}</span>
                    }
                </div>
            </div>
            {showParticipants &&
                <div className="chat-window-header-menu" title={intl.formatMessage({ id: "Opções do grupo" })}>
                    <ContextMenuButton
                        isVisible={!!groupMenu}
                        handleShowMenu={(e) => showGroupMenu({ ...e, item: group })}>
                        <MoreVertical size={16} />
                    </ContextMenuButton>
                </div>
            }
            <CommandBar size="sm" className="message-options-button">
                <CommandBar.Group>
                    <CommandBar.Item
                        color="warning"
                        description="Minimizar"
                        active={true}
                        badge={null}
                        onClick={closeChatWindow}>
                        <Minus size={12} />
                    </CommandBar.Item>
                </CommandBar.Group>
            </CommandBar>
            <ContextMenu {...groupMenu} handleCloseMenu={() => showGroupMenu(null)}>
                <ContextMenu.Item
                    visible={showParticipants}
                    onClick={() => openGroupManagement(GROUP_MANAGEMENT_VIEWS.PARTICIPANTS)}>
                    {intl.formatMessage({ id: "Participantes" })}
                </ContextMenu.Item>
                <ContextMenu.Item
                    visible={canManage}
                    onClick={() => openGroupManagement(GROUP_MANAGEMENT_VIEWS.RENAME)}>
                    {intl.formatMessage({ id: "Renomear grupo" })}
                </ContextMenu.Item>
                <ContextMenu.Item
                    visible={canManage}
                    onClick={() => openGroupManagement(GROUP_MANAGEMENT_VIEWS.DELETE)}>
                    <span className="text-danger">{intl.formatMessage({ id: "Excluir grupo" })}</span>
                </ContextMenu.Item>
            </ContextMenu>
        </div>
    )
}

export default GroupHeader;
